import { useState } from 'react';

interface Campaign {
  id: number;
  title: string;
  desc: string;
  oldPrice: string;
  newPrice: string;
  badge: string;
  badgeColor: string;
  image: string;
  tag: string;
  wide?: boolean;
}

interface Props {
  campaign: Campaign;
  onDetail: (id: number) => void;
}

export default function CampaignCard({ campaign, onDetail }: Props) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={`group relative rounded-2xl overflow-hidden border transition-all duration-400 cursor-pointer ${
        hovered ? 'border-[#d4af37]/60 -translate-y-2' : 'border-white/10'
      }`}
      style={{
        background: 'rgba(26, 26, 46, 0.8)',
        backdropFilter: 'blur(20px)',
        boxShadow: hovered ? '0 20px 60px rgba(212,175,55,0.15), 0 0 0 1px rgba(212,175,55,0.2)' : 'none',
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Image */}
      <div className={`relative overflow-hidden ${campaign.wide ? 'h-52' : 'h-44'}`}>
        <img
          src={campaign.image}
          alt={campaign.title}
          className={`w-full h-full object-cover object-top transition-transform duration-500 ${hovered ? 'scale-110' : 'scale-100'}`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0f] via-[#0a0a0f]/40 to-transparent" />

        {/* Badge */}
        <div
          className="absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-bold"
          style={{ background: `${campaign.badgeColor}20`, border: `1px solid ${campaign.badgeColor}60`, color: campaign.badgeColor }}
        >
          {campaign.badge}
        </div>

        {/* Tag */}
        <div className="absolute bottom-3 left-3 px-2 py-1 rounded-md bg-black/60 backdrop-blur-sm text-white/60 text-xs">
          {campaign.tag}
        </div>
      </div>

      {/* Content */}
      <div className="p-5">
        <h3 className="text-white font-bold text-lg mb-2">{campaign.title}</h3>
        <p className="text-white/50 text-sm leading-relaxed mb-4 line-clamp-2">{campaign.desc}</p>

        {/* Price */}
        <div className="flex items-center gap-3 mb-4">
          <span className="text-white/30 text-sm line-through">{campaign.oldPrice}</span>
          <span
            className="text-2xl font-black"
            style={{ background: 'linear-gradient(135deg, #d4af37, #f4d03f)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}
          >
            {campaign.newPrice}
          </span>
          <span className="ml-auto text-xs text-green-400 font-semibold bg-green-400/10 px-2 py-1 rounded-full">
            Tasarruf Et
          </span>
        </div>

        {/* CTA */}
        <button
          onClick={() => onDetail(campaign.id)}
          className={`w-full py-3 rounded-xl font-bold text-sm flex items-center justify-center gap-2 transition-all duration-300 cursor-pointer whitespace-nowrap ${
            hovered
              ? 'bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black'
              : 'border border-[#00d9ff]/50 text-[#00d9ff] hover:bg-[#00d9ff]/10'
          }`}
        >
          Detaylı İncele
          <i className="ri-arrow-right-line text-base"></i>
        </button>
      </div>
    </div>
  );
}
